module.exports = __webpack_public_path__ + "img/logo_headtopics.c4a55d6d.png";